import ChartBar from '../../../components/ChartBar';
import { buildReportChartData } from '../../../data/report/helpers/chartUtils';
import { getAccountType } from '../../../data/report/helpers/pricebookReportUtils';
import { LoginCountData, SummedReport } from '../../../models/ReportData';
import useChartTheme from '../../../themes/chart';

const loginCountMap = new Map<keyof LoginCountData, string>([
  ['webLoginsCount', 'Desktop'],
  ['appleMobileLoginsCount', 'Apple (mobile)'],
  ['appleWebLoginsCount', 'Apple (web)'],
  ['androidMobileLoginsCount', 'Android (mobile)'],
  ['androidWebLoginsCount', 'Android (web)'],
]);

interface LoginCountChartProps {
  summedReport: SummedReport;
}

const LoginCountChart: React.FC<LoginCountChartProps> = ({ summedReport }) => {
  const { chartColors } = useChartTheme();
  const chartData = buildReportChartData(
    summedReport,
    pricebookReport => getAccountType(pricebookReport?.productType),
    loginCountMap,
  );

  const dataSeries = Object.entries(chartData).map(([accountType, data]) => ({
    data,
    color: chartColors[accountType as keyof typeof chartColors],
    label: accountType,
  }));

  return (
    <ChartBar
      title='All-time count of logins per platform'
      dataSeries={dataSeries}
      yAxisLabel='Count per platform'
      seriesLabel='Account type'
      padding={{ bottom: 85 }}
    />
  );
};

export default LoginCountChart;
